import { createFileRoute } from '@tanstack/react-router';

import { ArticleSetupPage } from './-components/ArticleSetupPage';

export const Route = createFileRoute('/_authenticated/articles/new')({
    component: ArticleSetupPage,
});
